module.exports = __webpack_public_path__ + "static/media/tmobile_icon.5a60dc83.png";